import * as z from "zod/v4";

export const UrlSchema = z
  .string()
  .url()
  .refine((url) => url.startsWith("http://") || url.startsWith("https://"), {
    message: "URL must start with http:// or https://",
  });
export const UrlArraySchema = z.array(UrlSchema).max(30);
